module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMwNzNGNzk7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjQsNDhBMjQsMjQsMCwxLDEsNDgsMjQsMjQsMjQsMCwwLDEsMjQsNDhaTTI0LDFBMjMsMjMsMCwxLDAsNDcsMjQsMjMsMjMsMCwwLDAsMjQsMVoiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjI0IiBjeT0iMjQiIHI9IjguNzQiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/qcasino/icon-live-blue.svg
// module id = TPDM
// module chunks = 10